export default "__VITE_ASSET__CiGsFg3G__"